import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import '../../../assets/css/student/about/Pg.css';

const CircularProgress = ({ percentage, label, delay, isVisible }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!isVisible) return;
    const timer = setTimeout(() => {
      let current = 0;
      const interval = setInterval(() => {
        current += 1;
        setProgress(current);
        if (current >= percentage) clearInterval(interval);
      }, 15);

      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timer);
  }, [percentage, delay, isVisible]);

  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className="prefix-stat-item">
      <div className="prefix-circle-wrapper">
        <svg>
          <circle className="prefix-circle-bg" cx="75" cy="75" r={radius} />
          <circle
            className="prefix-circle-progress"
            cx="75"
            cy="75"
            r={radius}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
          />
        </svg>
        <div className="prefix-circle-text">
          {progress}<span>%</span>
        </div>
      </div>
      <h3>{label}</h3>
    </div>
  );
};

const AnimatedProgressSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const stats = [
    { percentage: 83, label: 'Hard Work', delay: 0 },
    { percentage: 100, label: 'Pure Love', delay: 200 },
    { percentage: 75, label: 'Smart Ideas', delay: 400 },
    { percentage: 65, label: 'Good Decisions', delay: 600 }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isVisible) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, [isVisible]);

  return (
    <div ref={sectionRef} className="prefix-stats-section">
      <Container>
        <Row className="g-4 justify-content-center pg-stats-container">
          {stats.map((stat, index) => (
            <Col key={index} xs={12} sm={6} lg={3}>
              <CircularProgress
                percentage={stat.percentage}
                label={stat.label}
                delay={stat.delay}
                isVisible={isVisible}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default AnimatedProgressSection;
